import { useParams } from 'react-router-dom';

import { ResultScreen } from '@/features/generation/ResultScreen';

export function ResultPage() {
  const { generationId } = useParams<{ generationId: string }>();

  if (!generationId) {
    return <p className="px-6 py-8 text-danger">Генерация не указана.</p>;
  }

  return (
    <main className="flex flex-col">
      <h1 className="px-6 pt-8 font-display text-h1 text-text">Результат</h1>
      <ResultScreen generationId={generationId} />
    </main>
  );
}
